import * as angular from "angular";
import {IController} from "angular";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class coordinationsTableCtrl implements IController {

  coordinations: any;
  queryString: string;
  declineCoordination: Function;

  /* @ngInject */
  constructor(private $log, private confirmDialogService: ConfirmDialogService) {
  }

  onDeclineCoordination(event, coordination) {
    const title = 'Decline Coordination #' + coordination.id,
      textContent = 'Are you sure you want to decline coordination?';

    this.confirmDialogService.confirm(title, textContent, event)
      .then(() => {
        this.declineCoordination({coordination: coordination})
      })
      .finally(() => {
        this.$log.info('Closed Dialog')
      })
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('coordinationsTable', {
    bindings: {
      coordinations: '<',
      queryString: '<',
      declineCoordination: '&'
    },
    template: require('./coordinations-table.html').default,
    controller: coordinationsTableCtrl
  });
